import image6972035 from "../../../../content/blog/assets/6972035_orig.png";
import * as React from 'react';
export default {
  image6972035,
  React
};